<template>
    <div class="proc-etapas-panel">
        <div class="form-panel-header">Etapas</div>

        <div class="proc-etapas-body">
            <div
                v-for="etapa in etapasVisiveis"
                :key="etapaKey(etapa)"
                class="proc-etapa-card"
                :class="{ 'proc-etapa-card--selected': etapa === etapaSelecionada }"
                @click="$emit('select', etapa)"
            >
                <div class="proc-etapa-ordem">
                    {{ etapa.ordem }}
                </div>

                <div class="proc-etapa-info">
                    <strong>{{ etapa.nmetapa || 'Etapa sem nome' }}</strong>
                    <span>{{ etapa.cdetapa }}</span>
                </div>

                <button
                    type="button"
                    class="btn-icon--trash proc-icon-btn"
                    title="Remover etapa"
                    @click.stop="$emit('remover', etapa)"
                />
            </div>

            <button type="button" class="btn-small proc-btn-add" @click="$emit('nova')">
                Nova Etapa
            </button>
        </div>
    </div>
</template>

<script setup>
import { computed } from 'vue';

const props = defineProps({
    etapas: {
        type: Array,
        required: true
    },
    etapaSelecionada: {
        type: Object,
        default: null
    }
});

defineEmits(['select', 'nova', 'remover']);

const etapasVisiveis = computed(() =>
    props.etapas
        .filter(e => e.ativo !== 'N')
        .sort((a, b) => Number(a.ordem || 0) - Number(b.ordem || 0))
);

function etapaKey(etapa) {
    return etapa.id > 0 ? etapa.id : `new-${etapa.ordem}-${etapa.cdetapa}`;
}
</script>